<template>
    <button class="button" @click="$emit('click')">
        <slot></slot>
    </button>
</template>

<style lang="scss" scoped>
@use '../styles/global.scss';
@use 'sass:color';

.button {
    appearance: none;
    font-family: inherit;
    font-size: 1.25em;
    font-weight: 700;
    padding: .5em 1em;
    border: none;
    border-radius: .15em;
    color: global.$mist;
    background-color: global.$emerald;
    cursor: pointer;
    transition: background-color .1s;

    &:hover {
        background-color: color.adjust(global.$emerald, $lightness: 5%);
    }
}
</style>